/** Settings › Voice parts: dictation anywhere, its shortcut and prompts, recent dictations, microphone and wake word. */
export default {
  doubleTapKeys: "Double-tap {keys}",
  pressKeys: "Press {keys}",
  dictation: "Dictation",
  dictateAnywhere: "Dictate in any app",
  pasteAutomatically: "Paste automatically",
  shortcutAndPrompts: "Shortcut and prompts",
  keyInUse: "Already in use, choose a key",
  promptDefault: "Default",
  promptNumber: "Prompt {number}",
  startAndStop: "Start and stop",
  stopWith: "Stop with",
  asSpokenNoAi: "As spoken, no AI",
  rewriteWithAi: "Rewrite with AI",
  addPrompt: "Add prompt",
  promptsFootnote:
    "{start} to stop with Default. While listening, press {modifier} and a number instead to stop and use that prompt.",
  chipCleanUp: "Clean up",
  chipMakeConcise: "Make concise",
  chipTranslate: "Translate",
  chipBulletPoints: "Bullet points",
  chipFormal: "Formal",
  toLanguage: "To {language}",
  dontTranslate: "Don’t translate",
  languageEnglish: "English",
  languageGerman: "German",
  languageSpanish: "Spanish",
  languageFrench: "French",
  languageChinese: "Chinese",
  languageJapanese: "Japanese",
  summaryCustom: "Custom",
  summaryAsSpoken: "As spoken",
  summarySeparator: " · ",
  addToInstructions: "Add to the instructions",
  instructions: "Instructions",
  instructionsPlaceholder: "Tell the AI how to rewrite what you said",
  shortcut: "Shortcut",
  toStop: "{start} to stop",
  whileListening: "{press} while listening",
  promptUnavailable: "Prompt unavailable.",
  name: "Name",
  deletePrompt: "Delete prompt",
  microphone: "Microphone",
  automatic: "Automatic",
  notConnected: "{name} (not connected)",
  noMicrophone: "No microphone found",
  usingDevice: "Using {name}",
  usingDeviceForNow: "Using {name} for now",
  wakeWord: "Wake word",
  wakeInvite: "Say “Denker” to start talking",
  wakeSleeping: "Sleeping — microphone listening for Denker",
  wakeWaking: "Preparing microphone…",
  wakeListening: "Awake — listening for requests",
  wakeUnavailable: "Wake listening unavailable",
  recentDictations: "Recent dictations",
  recentEmpty: "Your last three dictations will appear here",
  outcomePasted: "pasted",
  outcomeCopied: "copied",
  outcomeNotCopied: "not copied",
  outcomeInProgress: "in progress",
  notImproved: "Not improved",
  listSeparator: ", ",
  lineRest: "{when}, {outcome}",
  defaultHasNoInstructions: "Default has no instructions",
  noAiTool: "No AI tool connected",
  copyFailed: "Couldn’t copy. Try again.",
  retryFailed: "Couldn’t retry. Try again.",
  screenRecording: "Screen recording",
  remembered: "Remembered. Copy now gives the fixed text.",
  retry: "Retry",
  fixAWord: "Fix a word",
  copyImproved: "Copy improved",
  copyImageFailed: "Couldn’t copy the image. Try again.",
  imageCopied: "Image {number} copied",
  copyImage: "Copy image {number} of {total}",
  openFolderFailed:
    "Couldn’t open the recording folder. Check that it is still there.",
  openRecordingFailed:
    "Couldn’t open the recording. Check that the file is still there.",
  playClip: "Play clip {number}",
  clip: "Clip {number} · {seconds}s",
  openRecordingFolder: "Open recording folder",
  speaking: "Speaking",
  listening: "Listening",
  readRepliesAloud: "Read replies aloud",
  quietWhenHeard: "Stay quiet over music, videos and calls",
  quietWhenHeardLine:
    "While music or a video is playing, or another app is using your microphone (a call or meeting), Denker shows its replies with a soft tone instead of speaking them.",
  voice: "Voice",
  playSample: "Play a sample",
  optionDefault: "Default",
  addMoreVoices: "Add more voices",
  engine: "Engine",
  voiceEngine: "Voice engine",
  dictationEngine: "Dictation engine",
  windowsSettingsFailed: "Couldn't open Windows Settings: {error}",
  spokenLanguage: "Dictation language",
  automaticDetects: "Detects which of your languages you speak",
  languagesISpeak: "Languages I speak",
  moreLanguages: "More languages",
  addLanguages: "Add languages…",
  unavailableLanguage: "{language} (not available)",
  missingLanguage: "Not available on this computer, choose another",
  setupUsesEnglish: "Setup and voice commands use English",
  commandsNeedEnglish: "Voice commands still need English",
  modelWhisperBase: "Standard",
  modelWhisperBaseLine: "Every language",
  modelParakeet: "European languages",
  modelParakeetLine: "German, French, Spanish and 22 more",
  modelQwen3: "中文 · 日本語 · 한국어",
  modelQwen3Line: "Also mixes in English",
  modelEnglishStreaming: "English, live",
  modelEnglishStreamingLine: "Words appear while you speak",
  modelAccuracy: "{language} {percent}%",
  modelNotUsable: "Not usable for {language}",
  modelAccuracyNotMeasured: "Accuracy not measured",
  modelRecommended: "Recommended",
  modelDownloadSize: "{size} MB download",
  modelDownloadingLine: "Downloading {name}, {percent}%",
  modelDownloadFailedLine: "Couldn’t download {name}.",
  modelSpareLine: "{name} is downloaded · {size} MB",
  modelRemove: "Remove",
  modelRemoveTitle: "Remove {name}?",
  modelRemoveBody: "This frees {size} MB. You can download it again anytime.",
} as const;
